import { coreApi } from '@cp/shared/api/core';
import { ApiTags } from '@cp/shared/api/core/const';
import { generateApiUrl } from '@common/api/configure';
import { ApiRoute } from '@common/api/route';
import { apiRouteMethodDict } from '@common/api/routeMethod';
import { ApiRoutePathParams } from '@common/api/routePathParams';
import { PromocodeViewModel } from '@common/model/billing/promocode/view';
import { ClientBillingPromocodesUsagesRequest } from '@common/model/client/billing/promocodesUsages.request';
import { PromocodesUsageResponse } from '@common/model/billing/promocode';
import { PromocodeApiTags, tagTypes } from './tags';

export const promocodeApi = coreApi
  .enhanceEndpoints({
    addTagTypes: tagTypes,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getPromocode: builder.query<PromocodeViewModel, { id: string }>({
        query: (params) => ({
          url: `/billing/promocode/${params.id}`,
        }),
        providesTags: (_p, _q, r) => [{ type: PromocodeApiTags.Promocode, id: r.id }],
      }),
      activatePromocode: builder.mutation<PromocodeViewModel, ApiRoutePathParams[ApiRoute.ClientBillingPromocodesActivate]>({
        query: (params) => ({
          url: generateApiUrl(ApiRoute.ClientBillingPromocodesActivate, params),
          method: apiRouteMethodDict[ApiRoute.ClientBillingPromocodesActivate],
        }),
        invalidatesTags: [PromocodeApiTags.PromocodeUsages, ApiTags.ClientBillingSubscription],
      }),

      getPromocodeUsage: builder.query<PromocodesUsageResponse, { id: string }>({
        query: (params) => ({
          url: `/billing/promocode/${params.id}/usage`,
        }),
        providesTags: (_r, _e, { id }) => [{ type: PromocodeApiTags.PromocodeUsages, id }],
      }),

      getPromocodesUsages: builder.query<PromocodeViewModel[], ClientBillingPromocodesUsagesRequest>({
        query: (params) => ({
          url: generateApiUrl(ApiRoute.ClientBillingPromocodesUsagesGet),
          params,
          method: apiRouteMethodDict[ApiRoute.ClientBillingPromocodesUsagesGet],
        }),
        providesTags: (r, e, q) =>
          q.status ? ([{ id: q.status, type: PromocodeApiTags.PromocodeUsages }] as const) : [PromocodeApiTags.PromocodeUsages],
      }),
    }),
  });
